
import React, { Component } from 'react'
import '../stylesheets/home.sass'

export default class Home extends Component {
  render() {
    return (
      <div className='bg'>
        <div className="is-preload">
          <div id="main">
            <div className='page-title'>
              <h1>The Billock Family</h1>
              <span><h3><em>Est. 2012</em></h3></span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
